export default __webpack_public_path__ + "static/individual-b4668439ebf816bc922be65237aa3580.jpg";